"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-restricted-imports
const js_video_url_parser_1 = __importDefault(require("@daredrop/js-video-url-parser"));
const platforms_1 = require("root/src/shared/@types/platforms");
const twitchCollectionURL = 'twitch.tv/collections/';
const collectionUrlparser = (url) => {
    const urlSplit = url.split('/');
    const id = urlSplit[urlSplit.length - 1];
    return {
        provider: platforms_1.Platform.Twitch,
        mediaType: 'collection',
        id,
    };
};
const twitterUrl = 'twitter.com/';
const twitterUrlParser = (url) => ({
    provider: 'twitter',
    mediaType: 'text/html',
    id: url,
});
const youtubeClipUrl = 'youtube.com/clip/';
const youtubeShortsUrl = 'youtube.com/shorts/';
const youtubeClipParser = (url) => {
    const urlSplit = url.split('/');
    const id = urlSplit[urlSplit.length - 1];
    return {
        provider: platforms_1.Platform.YouTube,
        mediaType: 'clip',
        id,
    };
};
const youtubeShortsParser = (url) => {
    const urlSplit = new URL(url).pathname.split('/');
    const id = urlSplit[urlSplit.length - 1];
    return {
        provider: platforms_1.Platform.YouTube,
        mediaType: 'shorts',
        id,
    };
};
exports.default = (videoUrl) => {
    if (videoUrl && videoUrl.includes(twitchCollectionURL)) {
        return collectionUrlparser(videoUrl);
    }
    if (videoUrl && videoUrl.includes(twitterUrl)) {
        return twitterUrlParser(videoUrl);
    }
    if (videoUrl && videoUrl.includes(youtubeClipUrl)) {
        return youtubeClipParser(videoUrl);
    }
    if (videoUrl && videoUrl.includes(youtubeShortsUrl)) {
        return youtubeShortsParser(videoUrl);
    }
    return js_video_url_parser_1.default.parse(videoUrl);
};
